module.exports = __webpack_public_path__ + "img/corner-icon.26d0ce90.svg";